module.exports = "https://static.wagwalking.com/_next/static/images/dog-and-cat-background-banner-df74c551ea8c32cbbfbdf2105ab23981.png";